/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { ko } from './translations/ko'
import { ja } from './translations/ja'

i18n.use(initReactI18next).init({
    resources: {
        ko: { translation: ko },
        ja: { translation: ja },
    },
    lng: 'ko',
    fallbackLng: 'ko',
    interpolation: {
        escapeValue: false,
    },
})

export default i18n
